export default __webpack_public_path__ + "static/media/Access-Health-Support_224x224.fd1e1fe8.jpg";